import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.loadingSubject.asObservable();

  /**
   * Show the loader.
   */
  show() {
    this.loadingSubject.next(true);
  }

  /**
   * Hide the loader.
   */
  hide() {
    this.loadingSubject.next(false);
  }
}
